import React from 'react';
import { ProgressIndicatorProps } from './types';
import {
  PROGRESS_CONTAINER,
  PROGRESS_STEP_CIRCLE_BASE,
  PROGRESS_STEP_CIRCLE_COMPLETED,
  PROGRESS_STEP_CIRCLE_CURRENT,
  PROGRESS_STEP_CIRCLE_DEFAULT,
  PROGRESS_STEP_LINE_BASE,
  PROGRESS_STEP_LINE_COMPLETED,
  PROGRESS_STEP_LINE_DEFAULT,
} from './styles';

const stepCircleClass = (isCompleted: boolean, isCurrent: boolean): string => {
  if (isCompleted) return `${PROGRESS_STEP_CIRCLE_BASE} ${PROGRESS_STEP_CIRCLE_COMPLETED}`;
  if (isCurrent) return `${PROGRESS_STEP_CIRCLE_BASE} ${PROGRESS_STEP_CIRCLE_CURRENT}`;
  return `${PROGRESS_STEP_CIRCLE_BASE} ${PROGRESS_STEP_CIRCLE_DEFAULT}`;
};

const ProgressIndicator: React.FC<ProgressIndicatorProps> = ({ currentStep, totalSteps }) => {
  return (
    <div className={PROGRESS_CONTAINER}>
      {Array.from({ length: totalSteps }, (_, i) => {
        const step = i + 1;
        const isCompleted = step < currentStep;
        const isCurrent = step === currentStep;

        return (
          <React.Fragment key={step}>
            <div className="flex shrink-0 flex-col items-center gap-1.5" aria-current={isCurrent ? 'step' : undefined}>
              <div className={stepCircleClass(isCompleted, isCurrent)}>{isCompleted ? '✓' : step}</div>
              <span className={`text-center text-[11px] font-semibold ${isCurrent ? 'text-primary' : 'text-gray-500'}`}>{['URL入力', '画像確認', '情報の自動整理'][i] || `手順${step}`}</span>
            </div>
            {step < totalSteps && (
              <div
                className={`${PROGRESS_STEP_LINE_BASE} ${
                  step < currentStep ? PROGRESS_STEP_LINE_COMPLETED : PROGRESS_STEP_LINE_DEFAULT
                }`}
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default ProgressIndicator;
